import { delFromObj } from "../utils/delFromObj";

export const instantpayDashboardChecks = (obj) => {
  var data = delFromObj(obj, "status");

  if (data.pending_txn_details.records === "0") {
    delete data.pending_txn_details;
  } else {
    data["Require settlement"] = data.pending_txn_details;
    delete data.pending_txn_details;
  }
  if (data.processing_txn_details) {
    data["Processing transactions"] = data.processing_txn_details;
    delete data.processing_txn_details;
  }
  if (data.settled_txn_details) {
    data["Settled transactions"] = data.settled_txn_details;
    delete data.settled_txn_details;
  }
  if (data.abandoned_txn_details.records === "0") {
    delete data.abandoned_txn_details;
  } else {
    data["Abandoned transactions"] = data.abandoned_txn_details;
    delete data.abandoned_txn_details;
  }
  if (data.cancelled_txn_details.records === "0") {
    delete data.cancelled_txn_details;
  } else {
    data["Cancelled transactions"] = data.cancelled_txn_details;
    delete data.cancelled_txn_details;
  }
  return data;
};

